import { type AlignedHistory, type HistoryRow } from '#shared/types';
import { type Delta, deltaBetween } from './result-trend.logic';

/**
 * How this visit's value moved since the immediately previous visit that has
 * one. Against that visit only: an arrow per column would be four different
 * comparisons against today's value, dressed up as a trend.
 */
export function sinceLastVisit(row: Pick<HistoryRow, 'current' | 'cells'>): Delta | null {
  const previous = row.cells.find((cell) => cell !== null);
  if (!row.current || !previous) return null;
  return deltaBetween(
    { result: row.current.result, unit: row.current.unit },
    { result: previous.result, unit: previous.unit },
  );
}

/** The visits still ticked for printing, in column order. */
export function includedVisitIds(
  visits: AlignedHistory['visits'],
  excluded: ReadonlySet<number>,
): number[] {
  return visits.filter((visit) => !excluded.has(visit.report_id)).map((visit) => visit.report_id);
}

/** A new exclusion set with `reportId` ticked (`included`) or unticked. */
export function toggleExcluded(
  excluded: ReadonlySet<number>,
  reportId: number,
  included: boolean,
): Set<number> {
  const next = new Set(excluded);
  if (included) next.delete(reportId);
  else next.add(reportId);
  return next;
}
